import { MediaReport } from "../../constants/action-constants/MediaReportActionConstants";

const initialState = {
  // Download Media Report Modal
  openDownloadMediaReportModal: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    // Download Media Report Modal
    case MediaReport.OPEN_DOWNLOAD_MEDIA_REPORT_MODAL:
      return {
        ...state,
        openDownloadMediaReportModal: true,
      };
    case MediaReport.CLOSE_DOWNLOAD_MEDIA_REPORT_MODAL:
      return {
        ...state,
        openDownloadMediaReportModal: false,
      };

    default:
      return state;
  }
};
